import React from 'react';
import PropTypes from 'prop-types';

const ContactVG = ({ theme }) => (
    <section aria-label="Kontakt oss" className={theme.aboutvg}>
        <h1 className={theme.headline}>Kontakt oss</h1>
        <h2>Har du et nyhetstips, forslag til sak eller kommentar til innholdet på VG Nett?</h2>
        <div className={theme.lighthr}>
            <h3>Ta kontakt med vaktsjef:</h3>
            <dl>
                <dt>Send tips online</dt>
                <dd>
                    <a href="https://www.vg.no/tips-oss/">Bruk skjema</a>
                </dd>
                <dt>SMS / MMS</dt>
                <dd>
                    <a href="tel:2200">2200</a>
                </dd>
                <dt>Ring</dt>
                <dd>
                    <a href="tel:22000000">22 00 00 00</a>
                </dd>
                <dt>E-post til</dt>
                <dd>
                    <a href="mailto:2200@vg.no">tusentipset</a>
                </dd>
            </dl>
        </div>

        <div className={theme.lighthr}>
            <h3>Pressemelding til redaksjonen:</h3>
            <p>
                <a href="mailto:pressemeldinger@vg.no">pressemeldinger@vg.no</a>
            </p>
        </div>

        <div className={theme.lighthr}>
            <h3>Henvendelser om VG Helg:</h3>
            <p>
                <a href="mailto:vghelg@vg.no">vghelg@vg.no</a>
            </p>
        </div>

        <div className={theme.darkhr}>
            <h3>Kommentar til en spesifikk sak?</h3>
            <p>Klikk på navnet til journalisten i toppen av artikkelen for å ta direkte kontakt.</p>
        </div>

        <h2>Helgeabonnement - VG levert hjem</h2>
        <div className={theme.lighthr}>
            <p>
                <a href="https://kundeportal.vg.no/">
                    Kjøp helgebonnement, gjør endringer i abonnementet, meld bortreist.
                </a>
            </p>
        </div>
        <div className={theme.darkhr}>
            <h3>Ikke fått avisen?</h3>
            <dl>
                <dt>E-post:</dt>
                <dd>
                    <a href="mailto:kundeservice@abo.vg.no">kundeservice@abo.vg.no</a>
                </dd>
                <dt>Telefon:</dt>
                <dd>
                    <a href="tel:22000777">22 00 07 77</a>
                </dd>
            </dl>
        </div>

        <h2>Avissalg og distribusjon</h2>
        <div className={theme.lighthr}>
            <h3>Ved henvendelser angående avissalg:</h3>
            <p>
                <a href="mailto:kundeservice@vg.no">kundeservice@vg.no</a>
            </p>
        </div>
        <div className={theme.darkhr}>
            <p>
                Er du over 13 år, og ønsker å selge VG på søndager,{' '}
                <a href="http://www.md.no/">ta kontakt her.</a>
            </p>
        </div>

        <h2>Annonsèr i VG</h2>
        <div className={theme.darkhr}>
            <p>
                <a href="https://annonseweb.schibsted.no/">
                    Informasjon om priser, matereriell, formater og frister.
                </a>
            </p>
        </div>

        <h2>Besøksaddresse</h2>
        <div className={theme.lighthr}>
            <h3>Postadresse:</h3>
            <p>
                Verdens Gang AS
                <br />
                Postboks 1185
                <br />
                Sentrum 0107 Oslo
            </p>
        </div>
        <div className={theme.lighthr}>
            <h3>Besøksadresse:</h3>
            <p>
                Akersgata 55, 0180 Oslo
                <br />
                <a href="https://www.google.no/maps/place/Akersgata+55,+0180+Oslo/@59.9153665,10.7409502,17z/data=!3m1!4b1!4m5!3m4!1s0x46416e62d5089bd5:0x9da86b2ac96f02aa!8m2!3d59.915142!4d10.743943">
                    Åpne i Google Maps
                </a>
            </p>
        </div>
        <div className={theme.darkhr}>
            <h3>Sentralbord:</h3>
            <p>
                <a href="tel:22000000">22 00 00 00</a>
            </p>
        </div>
        <h2>VG+ Support</h2>
        <div className={theme.darkhr}>
            <h3>Kontakt oss:</h3>
            <dl>
                <dt>Via kontaktskjema:</dt>
                <dd>
                    <a href="https://support.pluss.vg.no/hc/no/requests/new">Åpne skjema</a>
                </dd>
                <dt>E-post:</dt>
                <dd>
                    <a href="mailto:vgpluss@vg.no">vgpluss@vg.no</a>
                </dd>
                <dt>Telefon:</dt>
                <dd>
                    <a href="tel:22000222">22 00 02 22</a> (11-12 på hverdager)
                </dd>
                <dt>Andre digitale henvendelser:</dt>
                <dd>
                    <a href="mailto:support@vg.no">support@vg.no</a>
                </dd>
            </dl>
        </div>
    </section>
);

ContactVG.propTypes = {
    theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ContactVG.defaultProps = {
    theme: {},
};

export default ContactVG;



/** WEBPACK FOOTER **
 ** ./src/local-components/about/ContactVG.js
 **/